var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCoverVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 53.5,
    viewBox: "0 0 95 53.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M0 0h95v154H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.33 13.33)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.712 27.854h-4.291a.2.2 0 0 1-.2-.2V.181A.182.182 0 0 1 16.402 0h4.31a7.142 7.142 0 0 1 7.142 7.142v13.57a7.142 7.142 0 0 1-7.142 7.142Zm1.02-15.354a2.816 2.816 0 1 0 2.816 2.82 2.82 2.82 0 0 0-2.816-2.82Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.23 27.854H7.142A7.142 7.142 0 0 1 0 20.712V7.142A7.142 7.142 0 0 1 7.142 0h6.088a.2.2 0 0 1 .2.2v27.45a.2.2 0 0 1-.2.204ZM7.142 2.246a4.9 4.9 0 0 0-4.9 4.9v13.57a4.9 4.9 0 0 0 4.9 4.9h4.047V2.246Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.619,
    cy: 2.619,
    r: 2.619,
    transform: "matrix(.025 -1 1 .025 4.272 10.909)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCoverVertical);
export default __webpack_public_path__ + "static/media/no-cover-vertical.79aba4c370bc01052751b475455ec6d7.svg";
export { ForwardRef as ReactComponent };